/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import router from '../router'
import {Message, MessageBox} from "element-ui";
import {getDataInLocalStorage, removeDataInLocalStorage} from "@/utils/localStorage";
import {isVersion} from "@/utils/utils";
import {modelInfo} from "@/utils/data/basicData/projectData";

let tokenExpiredStatus = false;
const common = {
    timeout: 0//不超时
}
// 登录过期提示
function tokenExpPrompt(){
    if (router.currentRoute.path !== '/login') {
        MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            router.push('/login')
        }).catch(() => {
            tokenExpiredStatus = false
        });
    }
}
function showError(message) {
    Message({ message, type: 'error' });
}

// 数据变更后通知父页面刷新红点（仅当被本地项目管理系统以 iframe 嵌入时）
function notifyParentRedDotRefresh(method) {
    const m = (method || 'get').toLowerCase();
    if (m === 'get') return;
    if (sessionStorage.getItem('fromIframe') !== '1') return;
    if (window.parent === window) return;
    window.parent.postMessage({ type: 'contract-red-dot-refresh' }, '*');
}

async function handleResponse(response) {
    try {
        if (response.data instanceof Blob) {
            const text = await response.data.text(); // 读取 Blob 为字符串
            const data = JSON.parse(text); // 解析为 JSON
            if (data.msg) {
                showError(data.msg); // 显示错误信息
            } else {
                showError('未知错误'); // 如果 msg 不存在，显示默认错误
            }
        }else{
            showError(response.data.msg)
            return Promise.resolve({code: response.data.code,msg:response.data.msg});
        }
    } catch (error) {
        console.log(error);
        showError('解析响应数据失败'); // 捕获并显示解析错误
    }
    return { code: '' }; // 返回默认对象
}
// 添加拦截器的响应处理
const responseHandler = response => {
    const {code} = {...response.data}
    let version = response.headers['client-version']
    if (version&&response.config.url !== '/login') {
        isVersion(version)
    }
    if ( response.headers['content-disposition']) {
        return {
            file: response.data,
            fileName: /filename\*=UTF-8''([^;\s]+)/.exec(response.headers['content-disposition'])[1]
        }
    }
    if (response.status === 200) {
        if (code === 200) {
            if (response.config.url.includes("/login")) {
                return Promise.resolve(response); //进行中
            } else {
                notifyParentRedDotRefresh(response.config.method);
                return Promise.resolve(response.data); //进行中
            }
        } else {
            if (code === 401) {
                removeDataInLocalStorage('token');
                if (!tokenExpiredStatus) {
                    tokenExpiredStatus = true;
                    tokenExpPrompt();
                }
                return {
                    code: ''
                };
            }
            handleResponse(response)
        }
    } else {
        Message.error(response.data.msg)
        return Promise.resolve({code: '',msg:response.data.msg}); //失败
    }
}
// 服务器状态码不是200的情况
const responseHandlerError = error => {
    // 对响应错误做点什么
    let {message} = error;
    if (message === "Request failed with status code 401") {
        if (!tokenExpiredStatus) {
            tokenExpiredStatus = true
            tokenExpPrompt()
        }
    } else if (message === "Request failed with status code 500") {
        Message.error('服务器后端异常，请稍后重试')
    } else {
        Message.error('网络异常，请稍后重试')
    }
}
const handleRequest = request => {
    request.headers.Authorization = getDataInLocalStorage('token')
    request.headers['Current-Role'] = getDataInLocalStorage('role')
    return request;
}
const handleRequestError = error => {
    return Promise.error(error);
}
let platApi={}
modelInfo.forEach(item=>{
    platApi[item.api.name]=axios.create(common)
    platApi[item.api.name].defaults.baseURL = item.api.url
    platApi[item.api.name].interceptors.request.use(handleRequest, handleRequestError)
    platApi[item.api.name].interceptors.response.use(responseHandler, responseHandlerError)
})

export const {contractApi}= platApi
